import { Link } from 'react-router-dom'
import PageFrame from '@/components/common/PageFrame'
import { buttonVariants } from '@/components/ui/button'
import { useHomePath } from '@/pages/WorkspaceHome'

export function NotFoundPage() {
  const home = useHomePath()
  return (
    <PageFrame title="Page not found" description="This address does not exist. Check the link, or go back to your home page.">
      <Link to={home} className={buttonVariants({ variant: 'outline' })}>
        Back to home
      </Link>
    </PageFrame>
  )
}
